import React from 'react';
import { CheckSquare, ChevronDown, Settings2, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export interface BulkActionsDropdownProps {
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const BulkActionsDropdown: React.FC<BulkActionsDropdownProps> = ({ onSelectAll, onDeselectAll }) => (
  <div className="flex items-center justify-end">
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-2">
          <Settings2 className="h-4 w-4" />
          Bulk Actions
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={onSelectAll}>
          <CheckSquare className="mr-2 h-4 w-4" />
          Select All
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDeselectAll}>
          <Square className="mr-2 h-4 w-4" />
          Deselect All
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);
